module.exports = __webpack_public_path__ + "img/vodacom-rugby-background-desktop.474cc905.png";